<script lang="ts">
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import {
    ensureFlixMediaDataAvailability,
    gtmForGeekOutHeader,
    hasDiscoverContent,
  } from '../services/pdp-data-services';
  import {
    flixMediaDataAvailable,
    isTTL24DataAvailable,
    pdpMoreInfoActiveTab,
    productDetailMainData,
  } from '../store/pdp_store';

  export let data: any;

  $: hasGroupedFeatures = Object.keys(data?.groupedfeatures || {}).length > 0;
  $: ensureFlixMediaDataAvailability(data);
  $: showDiscoverTab = hasDiscoverContent(
    data,
    $flixMediaDataAvailable,
    $isTTL24DataAvailable,
    $productDetailMainData.isMarketPlaceProduct
  );
  $: showGeekyInfoTab = data?.productSpecifications != null || hasGroupedFeatures || data?.classifications != null;
</script>

<ul class="specs-tabs-list">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  {#if showDiscoverTab}
    <li
      on:click={() => ($pdpMoreInfoActiveTab = 'Discover')}
      on:click={() => gtmForGeekOutHeader($pdpMoreInfoActiveTab, 'rank', 'highlight')}
      class={$pdpMoreInfoActiveTab == 'Discover' ? 'active' : ''}
    >
      <span class="tab-content">
        <span class="tab-icon">
          <Icon glyph="icon-package_tracking1" type="primary" mobileSize={20} desktopSize={20} />
        </span>
        <Text key="extra.pdp.discoverTab" />
      </span>
    </li>
  {/if}
  {#if showGeekyInfoTab}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li
      on:click={() => ($pdpMoreInfoActiveTab = 'GeekyInfo')}
      on:click={() => gtmForGeekOutHeader($pdpMoreInfoActiveTab, 'rank', 'highlight')}
      class={$pdpMoreInfoActiveTab == 'GeekyInfo' ? 'active' : ''}
    >
      <span class="tab-content">
        <span class="tab-icon">
          <Icon glyph="icon-service" type="primary" mobileSize={20} desktopSize={20} />
        </span>
        <Text key="extra.pdp.specsTab" />
      </span>
    </li>
  {/if}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <li
    on:click={() => ($pdpMoreInfoActiveTab = 'Reviews')}
    on:click={() => gtmForGeekOutHeader($pdpMoreInfoActiveTab, 'rank', 'highlight')}
    class={$pdpMoreInfoActiveTab == 'Reviews' ? 'active' : ''}
  >
    <span class="tab-content">
      <span class="tab-icon">
        <Icon glyph="icon-star1" type="primary" mobileSize={20} desktopSize={20} />
      </span>
      <Text key="extra.pdp.reviewsTab" />
    </span>
  </li>
  <!-- {/if} -->
</ul>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global {
    ul.specs-tabs-list {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    ul.specs-tabs-list {
      list-style: none;
      display: flex;
      justify-content: flex-start;
      border-bottom: 1px solid $secondary-gray-02;
      padding: 0 16px;
      overflow: scroll;
      height: 56px;
      gap: 18px;
      margin: 0;
      @include desktop-min-width {
        gap: 48px;
      }
      li {
        cursor: pointer;
        padding: 16px 0px;
        white-space: nowrap;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: $primary-black;
        @include desktop-min-width {
          font-size: 16px;
          line-height: 18px;
        }
        .tab-content {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          @include desktop-min-width {
            gap: 8px;
          }
          .tab-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 20px;
          }
          :global(.c_icon_new) {
            color: inherit;
          }
          :global(.primary-icon) {
            color: inherit;
            fill: currentColor;
            width: 20px;
            height: 20px;
          }
          :global(.primary-icon use) {
            fill: currentColor;
          }
        }
        &.active {
          border-bottom: 2px solid $primary-blue;
          color: $primary-blue;
          font-weight: 700;
          svg {
            stroke: $primary-blue;
          }
        }
      }
    }
  }
</style>
